// 存储消息的key
export const MESSAGE_KEY = 'jkt-cus'
// 存储 asstoken 的key
export const ACCESS_TOKEN_KEY = 'jkt-cus-access-token'
// 存储 refreshToken 的key
export const REFRESH_TOKEN_KEY = 'jkt-cus-refresh-token'